import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "navbar__container" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "airline-logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"cursor":"pointer"} }
const _hoisted_6 = { class: "langcode" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-language",
  "aria-hidden": "true",
  style: {"font-size":"32px"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "lang_list"
}
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StyledNavbar = _resolveComponent("StyledNavbar")!

  return (_openBlock(), _createBlock(_component_StyledNavbar, null, {
    default: _withCtx(() => [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.airlineLogo || `/images/logo.png`,
              alt: "Airline Logo",
              class: "airline-logo_img",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", {
                id: "lang_title",
                class: "lang_title language-option",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLangList = !_ctx.showLangList))
              }, [
                _hoisted_7,
                _hoisted_8,
                (_ctx.selectedLang)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.selectedLang), 1))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !_ctx.isPrintServicePage]
              ]),
              (_ctx.langs && _ctx.langs.length > 1)
                ? (_openBlock(), _createBlock(_Transition, {
                    key: 0,
                    name: "lang-fade"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showLangList)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (lang) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: lang.lang_code,
                                  class: _normalizeClass(lang.lang_code != _ctx.selectedLang ? '' : 'd-none'),
                                  onClick: ($event: any) => (_ctx.changeCurrentLanguage(lang.lang_code))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(lang.name), 1)
                                ], 10, _hoisted_11))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}